'use client';

import Link from 'next/link';
import { useAnalytics } from '@/services/frontendAnalyticsService';

interface BlogPostCtaSectionProps {
  postSlug: string;
  categorySlug: string | null;
  categoryName: string | null;
}

export function BlogPostCtaSection({
  postSlug,
  categorySlug,
  categoryName,
}: BlogPostCtaSectionProps) {
  const analytics = useAnalytics();

  const handleAllPostsClick = () => {
    analytics.blog.featuresCTAClicked({
      postSlug,
      ctaType: 'post-section',
      ctaLabel: 'Lihat Semua Kajian',
    });
  };

  const handleCategoryClick = () => {
    analytics.blog.featuresCTAClicked({
      postSlug,
      ctaType: 'post-section',
      ctaLabel: `Kajian ${categoryName} Lainnya`,
    });
  };

  return (
    <section className="relative px-4 py-16 md:px-8 lg:px-12 bg-white border-t border-neutral-100">
      <div className="max-w-4xl mx-auto text-center space-y-8">
        <h2 className="text-2xl md:text-3xl font-bold text-neutral-900 font-sans tracking-tight">
          Ingin Membaca Lebih Banyak?
        </h2>
        <div className="flex flex-wrap justify-center gap-4">
          <Link href="/blog/posts" onClick={handleAllPostsClick}>
            <button className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-neutral-900 text-white font-medium hover:bg-neutral-800 transition-colors text-sm">
              Lihat Semua Kajian
            </button>
          </Link>
          {categorySlug && categoryName && (
            <Link
              href={`/blog/posts?category=${categorySlug}`}
              onClick={handleCategoryClick}
            >
              <button className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-white border border-neutral-200 text-neutral-900 font-medium hover:bg-neutral-50 transition-colors text-sm">
                Kajian {categoryName} Lainnya
              </button>
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
